module.exports = __webpack_public_path__ + "img/pkszcrb.20b9e505.png";